import { render } from "./SupplierList.vue?vue&type=template&id=1b4c2ced"
import script from "./SupplierList.vue?vue&type=script&lang=ts"
export * from "./SupplierList.vue?vue&type=script&lang=ts"
script.render = render

export default script